/** Brief 12, Kapitan - Avtomatizatsiya: the rules and the campaigns. */
export const uzB12Automation = {
  "auto.tabs.label": "Avtomatizatsiya bo'limlari",
  "auto.tab.rules": "Avtomatizatsiyalar",
  "auto.tab.campaigns": "Kampaniyalar",
  "auto.rules.new": "+ Yangi qoida",
  "auto.rules.list": "Avtomatizatsiya qoidalari",
  "auto.rules.denied": "Avtomatizatsiyani faqat egasi boshqaradi.",
  "auto.rules.empty.title": "Qoida hali yo'q",
  "auto.rules.empty.message": "Birinchi qoidani yarating: qachon, qanday shartda va nima qilinsin.",
  "auto.rules.error": "Qoidalarni yuklab bo'lmadi.",
  "auto.retry": "Qayta urinish",
  "auto.kind.ai": "AI trigger",
  "auto.kind.rule": "Qoida",
  "auto.rule.toggle": "{name}: yoqish",
  "auto.rule.on": "Qoida yoqildi",
  "auto.rule.off": "Qoida o'chirildi",
  "auto.rule.toggleError": "Qoidani saqlab bo'lmadi",
  "auto.rule.never": "Hali ishlamagan",
  "auto.rule.last": "Oxirgi: {when}",
  "auto.rule.lastWeek": "Oxirgi: {when} · {count} marta / hafta",
  "auto.when.today": "bugun {time}",
  "auto.when.yesterday": "kecha {time}",
  "auto.part.hours": "{count} soat",
  "auto.part.days": "{count} kun",
  "auto.part.frozen": "bitim muzlatilgan",
  "auto.part.tags": "teg: {tags}",
  "auto.trigger.stage_reached": "Bosqichga yetdi",
  "auto.trigger.trip_ended": "Safardan keyin",
  "auto.trigger.payment_approved": "To'lov tasdiqlandi",
  "auto.trigger.proposal_opened": "Taklif sahifasi ochildi",
  "auto.trigger.birthday": "Tug'ilgan kun",
  "auto.trigger.no_reply": "Javob bermagan",
  "auto.trigger.offer_silent": "Taklif yuborildi, javob yo'q",
  "auto.action.send_template": "AI xabar yuborsin",
  "auto.action.create_task": "Vazifa yaratish",
  "auto.action.notify": "Mas'ulga bildirishnoma",
  "auto.trigger.stage_silent": "Bosqichda kun o'tdi",
  "auto.trigger.operator_silent": "Operator javob bermadi",
  "auto.action.remind_operator": "Operatorga eslatish",
  "auto.outcome.won": "Yutgan bitim",
  "auto.outcome.lost": "Yo'qotgan bitim",
  "auto.outcome.booked": "Bron qilingan bitim",
  "auto.form.title": "Yangi qoida",
  "auto.form.name": "Nomi",
  "auto.form.event": "Hodisa",
  "auto.form.condition": "Shart",
  "auto.form.action": "Harakat",
  "auto.form.always": "Har doim",
  "auto.form.frozen": "Bitim muzlatilgan",
  "auto.form.byTag": "Teg bo'yicha",
  "auto.form.tags": "Teglar (vergul bilan)",
  "auto.form.outcome": "Natija",
  "auto.form.hours": "Javob bermasa, soat",
  "auto.form.days": "Safar tugagandan keyin, kun",
  "auto.form.template": "Shablon",
  "auto.form.taskTitle": "Sarlavha",
  "auto.form.body": "Matn",
  "auto.form.choose": "Tanlang",
  "auto.form.preview": "QACHON «{event}» → AGAR «{condition}» → «{action}»",
  "auto.form.note": "Qoida o'chiq saqlanadi. Yoqish ro'yxatdan keyin.",
  "auto.form.cancel": "Bekor",
  "auto.form.save": "Saqlash",
  "auto.form.saved": "Qoida saqlandi",
  "auto.form.saveError": "Qoidani saqlab bo'lmadi",
  "auto.form.optionsError": "Qoida tanlovlarini yuklab bo'lmadi.",
  "auto.runs.title": "Yurituvlar: {name}",
  "auto.runs.empty": "Bu qoida hali yurmagan.",
  "auto.runs.error": "Yurituvlarni yuklab bo'lmadi.",
  "auto.runs.when": "Sana",
  "auto.runs.subject": "Ob'ekt",
  "auto.runs.status": "Holat",
  "auto.runs.reason": "Sabab",
  "auto.run.sent": "Bajarildi",
  "auto.run.skipped": "O'tkazildi",
  "auto.run.failed": "Xato",
  "camp.new": "+ Kampaniya",
  "camp.denied": "Kampaniyalarni menejer va egasi yuboradi.",
  "camp.empty.title": "Kampaniya hali yo'q",
  "camp.empty.message": "Birinchi kampaniyani tuzing: kimga, qaysi kanaldan va qachon.",
  "camp.error": "Kampaniyalarni yuklab bo'lmadi.",
  "camp.status.scheduled": "Rejalashtirilgan",
  "camp.status.draft": "Qoralama",
  "camp.status.sending": "Davom etmoqda",
  "camp.status.sent": "Yakunlandi",
  "camp.status.paused": "Pauzada",
  "camp.status.cancelled": "Bekor qilingan",
  "camp.channel.telegram": "Telegram",
  "camp.channel.instagram": "Instagram Direct",
  "camp.channel.any": "Har qanday kanal",
  "camp.meta.people": "{count} mijoz",
  "camp.meta.perDay": "kuniga {count}",
  "camp.bar.sent": "Yuborildi",
  "camp.bar.read": "O'qildi",
  "camp.bar.replied": "Javob berdi",
  "camp.form.title": "Yangi kampaniya",
  "camp.form.name": "Nomi",
  "camp.form.segment": "Segment",
  "camp.form.destination": "Yo'nalish",
  "camp.form.lastTrip": "Oxirgi safar",
  "camp.form.branch": "Filial",
  "camp.form.all": "Hammasi",
  "camp.form.trip6m": "6 oydan ko'p",
  "camp.form.trip1y": "1 yildan ko'p",
  "camp.form.audience": "Mos mijozlar: {count} · Telegram'da {telegram} · faqat rozilik berganlar",
  "camp.form.audienceLoading": "Mos mijozlar sanalmoqda",
  "camp.form.channel": "Kanal",
  "camp.form.template": "Shablon",
  "camp.form.noTemplate": "Shablonsiz",
  "camp.form.schedule": "Jadval",
  "camp.form.limit": "Kunlik limit",
  "camp.form.text": "Matn",
  "camp.form.warnOver": "Telegram limiti qat'iy: bitta agentlikdan kuniga {limit} tadan ko'p xabar bloklanishga olib keladi. Limit {limit} ga tushiriladi.",
  "camp.form.warnTelegram": "Telegram uchun limit qat'iy · kuniga {limit} ta, {days} kunda tugaydi. Instagram'ga ommaviy xabar Meta qoidasi bo'yicha faqat 24 soat ichida yozganlarga.",
  "camp.form.warnInstagram": "Instagram: faqat oxirgi 24 soatda yozgan mijozlarga yuboriladi (Meta qoidasi).",
  "camp.form.previewEmpty": "Xabar matni shu yerda ko'rinadi.",
  "camp.form.cancel": "Bekor",
  "camp.form.schedulePress": "Rejalashtirish",
  "camp.form.saved": "Kampaniya rejalashtirildi",
  "camp.form.draftSaved": "Kampaniya qoralama sifatida saqlandi",
  "camp.form.saveError": "Kampaniyani saqlab bo'lmadi",
  "camp.detail.results": "Natijalar",
  "camp.detail.previewError": "Ko'rinishni hisoblab bo'lmadi.",
  "camp.detail.recipients": "Qabul qiluvchilar",
  "camp.detail.client": "Mijoz",
  "camp.detail.state": "Holat",
  "camp.detail.willSend": "Yuboriladi: {count} ta mijoz",
  "camp.detail.send": "Yuborish",
  "camp.detail.confirm": "Yuborilsinmi?",
  "camp.detail.cancel": "Bekor qilish",
  "camp.detail.stop": "Kampaniyani to'xtatish",
  "camp.detail.stopped": "Kampaniya to'xtatildi",
  "camp.detail.stopError": "Kampaniyani to'xtatib bo'lmadi",
  "camp.detail.queued": "Kampaniya navbatga qo'yildi",
  "camp.detail.sendError": "Kampaniyani yuborib bo'lmadi",
  "camp.recipient.queued": "Navbatga qo'yildi",
  "camp.recipient.skipped_no_consent": "Marketing roziligi yo'q",
  "camp.recipient.skipped_no_channel": "Suhbat yo'q",
  "camp.recipient.skipped_not_allowed": "AI o'chiq yoki bloklangan",
} as const;
